import * as React from "react";

const SvgComponent = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    style={{
      height: "40px",
      width: "100px",
    }}
  >
    <defs>
      <clipPath id="clip-path">
        <circle
          cx={50}
          cy={50}
          r={48.44}
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <style>
        {".cls-3,.cls-72{fill:#72b4f5;fill-rule:evenodd}.cls-72{fill:#356ebf}"}
      </style>
    </defs>
    <g
      style={{
        clipPath: "url(#clip-path)",
      }}
    >
      <path className="cls-3" d="M34.51 1.56 1.56 19.73V1.56h32.95z" />
      <path
        className="cls-3"
        d="M37.02 1.56 1.56 21.12v-1.39L34.51 1.56h2.51z"
      />
      <path
        style={{
          fill: "#71b3f4",
          fillRule: "evenodd",
        }}
        d="M39.54 1.56 1.56 22.51v-1.39L37.02 1.56h2.52z"
      />
      <path
        style={{
          fill: "#70b2f3",
          fillRule: "evenodd",
        }}
        d="M42.05 1.56 1.56 23.89v-1.38L39.54 1.56h2.51z"
      />
      <path
        style={{
          fill: "#6fb1f3",
          fillRule: "evenodd",
        }}
        d="m44.56 1.56-43 23.72v-1.39L42.05 1.56h2.51z"
      />
      <path
        style={{
          fill: "#6eb0f2",
          fillRule: "evenodd",
        }}
        d="M47.08 1.56 1.56 26.67v-1.39l43-23.72h2.52z"
      />
      <path
        style={{
          fill: "#6eaff1",
          fillRule: "evenodd",
        }}
        d="M49.59 1.56 1.56 28.05v-1.38L47.08 1.56h2.51z"
      />
      <path
        style={{
          fill: "#6daef0",
          fillRule: "evenodd",
        }}
        d="M52.11 1.56 1.56 29.44v-1.39L49.59 1.56h2.52z"
      />
      <path
        style={{
          fill: "#6cadf0",
          fillRule: "evenodd",
        }}
        d="M54.62 1.56 1.56 30.82v-1.38L52.11 1.56h2.51z"
      />
      <path
        style={{
          fill: "#6bacef",
          fillRule: "evenodd",
        }}
        d="M57.13 1.56 1.56 32.21v-1.39L54.62 1.56h2.51z"
      />
      <path
        style={{
          fill: "#6aabee",
          fillRule: "evenodd",
        }}
        d="M59.65 1.56 1.56 33.6v-1.39L57.13 1.56h2.52z"
      />
      <path
        style={{
          fill: "#69aaed",
          fillRule: "evenodd",
        }}
        d="M62.16 1.56 1.56 34.98V33.6L59.65 1.56h2.51z"
      />
      <path
        style={{
          fill: "#68a9ec",
          fillRule: "evenodd",
        }}
        d="M64.67 1.56 1.56 36.37v-1.39l60.6-33.42h2.51z"
      />
      <path
        style={{
          fill: "#67a8ec",
          fillRule: "evenodd",
        }}
        d="M67.19 1.56 1.56 37.76v-1.39L64.67 1.56h2.52z"
      />
      <path
        style={{
          fill: "#67a7eb",
          fillRule: "evenodd",
        }}
        d="M69.7 1.56 1.56 39.14v-1.38l65.63-36.2h2.51z"
      />
      <path
        style={{
          fill: "#66a6ea",
          fillRule: "evenodd",
        }}
        d="M72.21 1.56 1.56 40.53v-1.39L69.7 1.56h2.51z"
      />
      <path
        style={{
          fill: "#65a5e9",
          fillRule: "evenodd",
        }}
        d="M74.73 1.56 1.56 41.91v-1.38L72.21 1.56h2.52z"
      />
      <path
        style={{
          fill: "#64a4e8",
          fillRule: "evenodd",
        }}
        d="M77.24 1.56 1.56 43.3v-1.39L74.73 1.56h2.51z"
      />
      <path
        style={{
          fill: "#63a3e8",
          fillRule: "evenodd",
        }}
        d="M79.75 1.56 1.56 44.69V43.3L77.24 1.56h2.51z"
      />
      <path
        style={{
          fill: "#62a2e7",
          fillRule: "evenodd",
        }}
        d="M82.27 1.56 1.56 46.07v-1.38L79.75 1.56h2.52z"
      />
      <path
        style={{
          fill: "#61a1e6",
          fillRule: "evenodd",
        }}
        d="M84.78 1.56 1.56 47.46v-1.39L82.27 1.56h2.51z"
      />
      <path
        style={{
          fill: "#60a0e5",
          fillRule: "evenodd",
        }}
        d="M87.29 1.56 1.56 48.85v-1.39l83.22-45.9h2.51z"
      />
      <path
        style={{
          fill: "#5f9fe5",
          fillRule: "evenodd",
        }}
        d="M89.81 1.56 1.56 50.23v-1.38L87.29 1.56h2.52z"
      />
      <path
        style={{
          fill: "#5f9ee4",
          fillRule: "evenodd",
        }}
        d="M92.32 1.56 1.56 51.62v-1.39L89.81 1.56h2.51z"
      />
      <path
        style={{
          fill: "#5e9de3",
          fillRule: "evenodd",
        }}
        d="M94.83 1.56 1.56 53.01v-1.39L92.32 1.56h2.51z"
      />
      <path
        style={{
          fill: "#5d9ce2",
          fillRule: "evenodd",
        }}
        d="M97.35 1.56 1.56 54.39v-1.38L94.83 1.56h2.52z"
      />
      <path
        style={{
          fill: "#5c9be1",
          fillRule: "evenodd",
        }}
        d="M98.44 2.35 1.56 55.78v-1.39L97.35 1.56h1.09v.79z"
      />
      <path
        style={{
          fill: "#5b9ae1",
          fillRule: "evenodd",
        }}
        d="M98.44 3.73 1.56 57.16v-1.38L98.44 2.35v1.38z"
      />
      <path
        style={{
          fill: "#5a99e0",
          fillRule: "evenodd",
        }}
        d="M98.44 5.12 1.56 58.55v-1.39L98.44 3.73v1.39z"
      />
      <path
        style={{
          fill: "#5998df",
          fillRule: "evenodd",
        }}
        d="M98.44 6.51 1.56 59.94v-1.39L98.44 5.12v1.39z"
      />
      <path
        style={{
          fill: "#5897de",
          fillRule: "evenodd",
        }}
        d="M98.44 7.89 1.56 61.32v-1.38L98.44 6.51v1.38z"
      />
      <path
        style={{
          fill: "#5796de",
          fillRule: "evenodd",
        }}
        d="M98.44 9.28 1.56 62.71v-1.39L98.44 7.89v1.39z"
      />
      <path
        style={{
          fill: "#5795dd",
          fillRule: "evenodd",
        }}
        d="M98.44 10.66 1.56 64.1v-1.39L98.44 9.28v1.38z"
      />
      <path
        style={{
          fill: "#5694dc",
          fillRule: "evenodd",
        }}
        d="M98.44 12.05 1.56 65.48V64.1l96.88-53.44v1.39z"
      />
      <path
        style={{
          fill: "#5593db",
          fillRule: "evenodd",
        }}
        d="M98.44 13.44 1.56 66.87v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#5492da",
          fillRule: "evenodd",
        }}
        d="M98.44 14.82 1.56 68.25v-1.38l96.88-53.43v1.38z"
      />
      <path
        style={{
          fill: "#5390da",
          fillRule: "evenodd",
        }}
        d="M98.44 16.21 1.56 69.64v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#528fd9",
          fillRule: "evenodd",
        }}
        d="M98.44 17.6 1.56 71.03v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#518ed8",
          fillRule: "evenodd",
        }}
        d="M98.44 18.98 1.56 72.41v-1.38L98.44 17.6v1.38z"
      />
      <path
        style={{
          fill: "#508dd7",
          fillRule: "evenodd",
        }}
        d="M98.44 20.37 1.56 73.8v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#508cd6",
          fillRule: "evenodd",
        }}
        d="M98.44 21.75 1.56 75.19V73.8l96.88-53.43v1.38z"
      />
      <path
        style={{
          fill: "#4f8bd6",
          fillRule: "evenodd",
        }}
        d="M98.44 23.14 1.56 76.57v-1.38l96.88-53.44v1.39z"
      />
      <path
        style={{
          fill: "#4e8ad5",
          fillRule: "evenodd",
        }}
        d="M98.44 24.53 1.56 77.96v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#4d89d4",
          fillRule: "evenodd",
        }}
        d="M98.44 25.91 1.56 79.34v-1.38l96.88-53.43v1.38z"
      />
      <path
        style={{
          fill: "#4c88d3",
          fillRule: "evenodd",
        }}
        d="M98.44 27.3 1.56 80.73v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#4b87d3",
          fillRule: "evenodd",
        }}
        d="M98.44 28.69 1.56 82.12v-1.39L98.44 27.3v1.39z"
      />
      <path
        style={{
          fill: "#4a86d2",
          fillRule: "evenodd",
        }}
        d="M98.44 30.07 1.56 83.5v-1.38l96.88-53.43v1.38z"
      />
      <path
        style={{
          fill: "#4985d1",
          fillRule: "evenodd",
        }}
        d="M98.44 31.46 1.56 84.89V83.5l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#4884d0",
          fillRule: "evenodd",
        }}
        d="M98.44 32.85 1.56 86.28v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#4883cf",
          fillRule: "evenodd",
        }}
        d="M98.44 34.23 1.56 87.66v-1.38l96.88-53.43v1.38z"
      />
      <path
        style={{
          fill: "#4782cf",
          fillRule: "evenodd",
        }}
        d="M98.44 35.62 1.56 89.05v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#4681ce",
          fillRule: "evenodd",
        }}
        d="M98.44 37 1.56 90.44v-1.39l96.88-53.43V37z"
      />
      <path
        style={{
          fill: "#4580cd",
          fillRule: "evenodd",
        }}
        d="M98.44 38.39 1.56 91.82v-1.38L98.44 37v1.39z"
      />
      <path
        style={{
          fill: "#447fcc",
          fillRule: "evenodd",
        }}
        d="M98.44 39.78 1.56 93.21v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#437ecc",
          fillRule: "evenodd",
        }}
        d="M98.44 41.16 1.56 94.59v-1.38l96.88-53.43v1.38z"
      />
      <path
        style={{
          fill: "#427dcb",
          fillRule: "evenodd",
        }}
        d="M98.44 42.55 1.56 95.98v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#417cca",
          fillRule: "evenodd",
        }}
        d="M98.44 43.94 1.56 97.37v-1.39l96.88-53.43v1.39z"
      />
      <path
        style={{
          fill: "#407bc9",
          fillRule: "evenodd",
        }}
        d="M98.44 45.32 2.13 98.44h-.57v-1.07l96.88-53.43v1.38z"
      />
      <path
        style={{
          fill: "#407ac8",
          fillRule: "evenodd",
        }}
        d="M98.44 46.71 4.65 98.44H2.13l96.31-53.12v1.39z"
      />
      <path
        style={{
          fill: "#3f79c8",
          fillRule: "evenodd",
        }}
        d="M98.44 48.09 7.16 98.44H4.65l93.79-51.73v1.38z"
      />
      <path
        style={{
          fill: "#3e78c7",
          fillRule: "evenodd",
        }}
        d="M98.44 49.48 9.67 98.44H7.16l91.28-50.35v1.39z"
      />
      <path
        style={{
          fill: "#3d77c6",
          fillRule: "evenodd",
        }}
        d="M98.44 50.87 12.19 98.44H9.67l88.77-48.96v1.39z"
      />
      <path
        style={{
          fill: "#3c76c5",
          fillRule: "evenodd",
        }}
        d="M98.44 52.25 14.7 98.44h-2.51l86.25-47.57v1.38z"
      />
      <path
        style={{
          fill: "#3b75c4",
          fillRule: "evenodd",
        }}
        d="m98.44 53.64-81.23 44.8H14.7l83.74-46.19v1.39z"
      />
      <path
        style={{
          fill: "#3a74c4",
          fillRule: "evenodd",
        }}
        d="M98.44 55.03 19.73 98.44h-2.52l81.23-44.8v1.39z"
      />
      <path
        style={{
          fill: "#3973c3",
          fillRule: "evenodd",
        }}
        d="m98.44 56.41-76.2 42.03h-2.51l78.71-43.41v1.38z"
      />
      <path
        style={{
          fill: "#3972c2",
          fillRule: "evenodd",
        }}
        d="M98.44 57.8 24.75 98.44h-2.51l76.2-42.03v1.39z"
      />
      <path
        style={{
          fill: "#3871c1",
          fillRule: "evenodd",
        }}
        d="M98.44 59.19 27.27 98.44h-2.52L98.44 57.8v1.39z"
      />
      <path
        style={{
          fill: "#3770c1",
          fillRule: "evenodd",
        }}
        d="M98.44 60.57 29.78 98.44h-2.51l71.17-39.25v1.38z"
      />
      <path
        style={{
          fill: "#366fc0",
          fillRule: "evenodd",
        }}
        d="M98.44 61.96 32.3 98.44h-2.52l68.66-37.87v1.39z"
      />
      <path
        className="cls-72"
        d="m98.44 63.34-63.63 35.1H32.3l66.14-36.48v1.38z"
      />
      <path className="cls-72" d="m34.81 98.44 63.63-35.1v35.1H34.81z" />
    </g>
    <path
      d="M50 100A50 50 0 0 1 30.54 3.93a50 50 0 0 1 38.92 92.14A49.61 49.61 0 0 1 50 100Zm0-96.88a46.89 46.89 0 0 0-18.25 90.07 46.89 46.89 0 0 0 36.5-86.38A46.5 46.5 0 0 0 50 3.12Z"
      style={{
        fill: "#daefff",
      }}
    />
    <path
      d="M69.62 32.46q6.51 0 10.09 4.46t3.62 12.57q0 8.13-3.65 12.65a12.18 12.18 0 0 1-10.06 4.5 14.64 14.64 0 0 1-5.91-1.18 11.2 11.2 0 0 1-4.46-3.68h-.36l-1 4.25h-3.64V19.14h5v11.39q0 3.82-.24 6.87h.24q3.49-4.93 10.37-4.94Zm-.72 4.19q-5.13 0-7.39 3t-2.26 9.89q0 7 2.32 10t7.45 3a7.74 7.74 0 0 0 6.87-3.35c1.5-2.25 2.26-5.47 2.26-9.67s-.76-7.51-2.26-9.62-3.84-3.16-7-3.16Z"
      style={{
        fill: "#fff",
        fillRule: "evenodd",
      }}
    />
    <path
      d="M31 62.45q5 0 7.3-2.69c1.52-1.78 2.34-4.8 2.44-9v-1.15q0-6.93-2.35-10t-7.45-3A7.69 7.69 0 0 0 24.17 40c-1.54 2.28-2.32 5.49-2.32 9.65s.77 7.33 2.29 9.52A7.87 7.87 0 0 0 31 62.45Zm-.75 4.19a12 12 0 0 1-10-4.5q-3.6-4.48-3.59-12.53T20.29 37a12.13 12.13 0 0 1 10.06-4.6 12 12 0 0 1 10.43 5.12h.27l.72-4.52h3.95v47.86h-5V66.73a33.93 33.93 0 0 1 .33-5.13h-.39q-3.46 5-10.43 5Z"
      style={{
        fill: "#c8e8ff",
        fillRule: "evenodd",
      }}
    />
  </svg>
);

export default SvgComponent;
